export const obtenerPorcentaje = ({total, valor=0, decimales=0}) =>{

    if (valor === 0){
        return 0
    }

    return (valor * 100 / total).toFixed(decimales)
}